<script>
import OwTable from '@/components/common/OwTable';
import TableRow from '@/components/statistics/TableRow';

export default {
    name: 'StatisticsTable',
    extends: OwTable,
    props: {
        headers: {
            type: Array,
            default: () => [
                'model', 'count',
            ],
        },
        tableRowComponent: {
            type: Object,
            default: () => TableRow,
        },
    },
};
</script>
